// Display labels for ChatClassification plus a few pipeline / historical slugs
// that may still appear in usage rows. Do not alias a retired slug onto a live
// classification — the dashboard Type filter matches on these labels.
export const CLASSIFICATION_LABELS: Record<string, string> = {
  general_question: "General Question",
  policy_researcher: "Policy Research",
  pre_service_reviewer: "Pre-Service Review",
  claim_reviewer: "Claim Review",
  appeal_strategy: "Appeal Strategy",
  dofr_appeal: "DOFR Appeal",
  claim_appeal_writer: "Appeal Letter",
  appeal_letter_writer: "Appeal Letter",
  dofr_letter_writer: "DOFR Letter",
  intake: "Claim Intake",
  review_orchestrator: "Quality Review",
  payment_validation: "Payment Review",
  coding_validation: "Coding Review",
  synthesis: "Claim Summary",
};

// Title-cases an underscore-delimited value; used as the fallback when a
// classification is not in CLASSIFICATION_LABELS.
export const formatAgentLabel = (value: string): string =>
  CLASSIFICATION_LABELS[value] ??
  value
    .split("_")
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");

export const formatAgentTypeLabel = (
  value: string | null | undefined,
): string => (value ? formatAgentLabel(value) : "");
